import {
  ATTRIBUTION,
  DEFAULT_ATTRIBUTION,
  DEFAULT_CONSENT,
  DEFAULT_EXPIRY_DAYS
} from './constants';

// Everything a site may need to change once Kelsey confirm their requirements,
// set per project in blaze.config:
//
//   config.plugins.set(campaign, {
//     attribution: 'first',
//     expiryDays: 30,
//     consent: { mode: 'didomi', purposes: ['…'], vendors: ['…'] }
//   });
//
// `consent` replaces the default as a whole rather than merging, so a mode is
// never paired with options meant for another one.
const defaults = {
  attribution: DEFAULT_ATTRIBUTION,
  expiryDays: DEFAULT_EXPIRY_DAYS,
  consent: DEFAULT_CONSENT
};

let config = { ...defaults };

const isValidAttribution = value => Object.values(ATTRIBUTION).includes(value);
const isValidExpiry = value => typeof value === 'number' && Number.isFinite(value) && value > 0;
const isValidConsent = value => !!value && typeof value === 'object' && !!value.mode;

// Ignores missing or invalid options so a partial config only overrides what it
// sets correctly, and a typo falls back to the default rather than breaking capture.
export function setPluginConfig(options = {}) {
  const { attribution, expiryDays, consent } = options;

  config = {
    attribution: isValidAttribution(attribution) ? attribution : defaults.attribution,
    expiryDays: isValidExpiry(expiryDays) ? expiryDays : defaults.expiryDays,
    consent: isValidConsent(consent) ? consent : defaults.consent
  };
  return config;
}

export function getPluginConfig() {
  return config;
}

export function resetPluginConfig() {
  config = { ...defaults };
  return config;
}
